"use client"

import { CheckCircle2, AlertCircle, AlertTriangle, Info, Bell } from "lucide-react"
import { cn } from "@/lib/utils"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { useToast } from "@/components/ui/use-toast"

const variantConfig = {
  default:     { Icon: Bell,          iconClass: "text-accent" },
  destructive: { Icon: AlertCircle,   iconClass: "text-destructive" },
  success:     { Icon: CheckCircle2,  iconClass: "text-success" },
  warning:     { Icon: AlertTriangle, iconClass: "text-warning" },
  info:        { Icon: Info,          iconClass: "text-info" },
} as const

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, variant = "default", ...props }) => {
        const { Icon, iconClass } =
          variantConfig[variant as keyof typeof variantConfig] ?? variantConfig.default

        return (
          <Toast key={id} variant={variant} {...props}>
            <Icon className={cn("w-4 h-4 flex-shrink-0 mt-[1px] [stroke-width:2.2]", iconClass)} />
            <div className="flex-1 min-w-0">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
